<template>
	<section v-if="recentDecks.length > 0" class="recent-decks">
		<nav>
			<h3>Recently Opened</h3>
			<ul>
				<li v-for="deck in recentDecks" :key="deck.name">
					<router-link
						:to="{
							name: 'listEditor',
							params: { deckPath: deck.path },
						}"
						@click="
							gtagEvent('footer_deck_menu_item_click', {
								NUM_DECKS: $store.state.decks.length,
							})
						"
					>
						<span class="deck-name">
							{{ deck.name }}
						</span>
						<div class="deck-colors">
							<div
								:class="sizeManaSymbols(deck)"
								v-html="renderManaSymbols(deck)"
							></div>
						</div>
					</router-link>
				</li>
			</ul>
		</nav>
	</section>
</template>

<script>
import { event as gtagEvent } from 'vue-gtag'
import deckColors from '@/mixins/deckColors.js'

export default {
	mixins: [deckColors],
	data() {
		return {
			recentDecks: [],
		}
	},
	watch: {
		'$route.params.deckPath'() {
			this.generateRecentDeckList()
		},
		'$store.state.decks.length'() {
			this.generateRecentDeckList()
		},
	},
	mounted() {
		if (!this.$route.params.deckPath) {
			this.generateRecentDeckList()
		}
	},
	methods: {
		gtagEvent, // For `vue-gtag` in the Vue <template>.
		generateRecentDeckList() {
			const deckPath = this.$route.params.deckPath
			let decks = [...this.$store.state.decks]

			if (deckPath) {
				// Exclude the currently open deck from the recent decks list.
				decks = decks.filter((d) => d.path !== deckPath)
			}

			this.recentDecks = decks
				.sort((a, b) => {
					// Sort decks by their open date, most recent first.
					return (
						new Date(b.openDate ?? b.editDate) -
						new Date(a.openDate ?? a.editDate)
					)
				})
				.slice(0, 5) // Set the maximum number of recent decks to display at a time.
		},
	},
}
</script>

<style lang="scss">
@use '@/sass/recent-decks.scss';
</style>
